const $$splitComponentImporter = () => import('/app/src/routes/dashboard/supervisor/billing.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/supervisor/billing")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});